// extracted by mini-css-extract-plugin
module.exports = {"commImageWrapper":"Success_commImageWrapper__2cKAo"};